(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupHeroVideo(video, poster) {
    function hidePoster() {
      video.classList.add('is-playing');
      poster?.classList.add('is-hidden');
    }

    function loadAndPlay() {
      if (video.dataset.loaded) return;
      video.dataset.loaded = 'true';
      video.preload = 'auto';
      video.load();
      video.play().catch(() => {});
    }

    video.addEventListener('playing', hidePoster, { once: true });

    if (reducedMotion) return;

    // Defer video download until after first paint so poster is the LCP element.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadAndPlay, { timeout: 2000 });
    } else {
      window.addEventListener('load', loadAndPlay, { once: true });
    }
  }

  function bind(root = document) {
    root.querySelectorAll('[data-xo-hero]:not([data-xo-hero-bound])').forEach(setup);
  }

  function setup(hero) {
    hero.dataset.xoHeroBound = 'true';

    const image = hero.querySelector('[data-xo-hero-image]');
    const overlay = hero.querySelector('[data-xo-hero-overlay]');
    const content = hero.querySelector('.xo-hero__content');
    const featured = hero.querySelector('.xo-hero__featured');
    const video = hero.querySelector('[data-xo-hero-video]');
    const poster = hero.querySelector('[data-xo-hero-poster]');
    if (!image && !overlay) return;

    if (video) {
      setupHeroVideo(video, poster);
    }

    let ticking = false;
    let progress = 0;

    function compute() {
      const rect = hero.getBoundingClientRect();
      const heroHeight = rect.height || 1;
      const viewportHeight = window.innerHeight || 1;

      // 0 when top of hero is at top of viewport, 1 when hero has scrolled fully out of view.
      const scrolled = Math.max(0, -rect.top);
      progress = Math.min(1, scrolled / heroHeight);

      // Clip each fixed element to the hero's viewport rect. position:fixed
      // ignores ancestor overflow so we have to enforce "stay inside the hero"
      // with clip-path. As the hero's bottom edge scrolls up, the bottom of
      // the fixed content is clipped at that exact line — no bleed onto the
      // sections below.
      clipToHero(content, rect);
      clipToHero(featured, rect);

      // Hide entirely when hero is fully off-screen (defensive, also helps
      // the browser skip painting the clipped element).
      const inView = rect.bottom > 0 && rect.top < viewportHeight;
      hero.style.setProperty('--xo-hero-visibility', inView ? 'visible' : 'hidden');

      apply();
    }

    function clipToHero(el, heroRect) {
      if (!el) return;
      const r = el.getBoundingClientRect();
      const top = Math.max(0, heroRect.top - r.top);
      const bottom = Math.max(0, r.bottom - heroRect.bottom);
      el.style.clipPath = `inset(${top}px 0 ${bottom}px 0)`;
    }

    function apply() {
      const value = progress.toFixed(4);
      // Set progress on the section itself so both the parallax image, the
      // overlay, AND the position:fixed text/featured card (which are
      // DOM-descendants of the section) can read it via CSS variable inheritance.
      hero.style.setProperty('--xo-hero-progress', value);
      // Disable pointer events on the fixed text/CTA once they've faded out so
      // they don't intercept clicks on whatever sits underneath them.
      hero.style.setProperty('--xo-hero-pointer-events', progress >= 0.95 ? 'none' : 'auto');
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(compute);
        ticking = true;
      }
    }

    if (reducedMotion) {
      // Lock to a static slight darkness for visual interest, no parallax.
      progress = 0.15;
      apply();
      return;
    }

    compute();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind());
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) bind(event.target);
  });

  window.addEventListener('pagereveal', () => bind());
})();
